export const SESSION_V3_GOODBYE_COMPLETED = '@ZAPI_SESSION_V3_GOODBYE_COMPLETED';
export const SESSION_V3_HELLO_COMPLETED = '@ZAPI_SESSION_V3_HELLO_COMPLETED';
export const SESSION_V3_RECEIVED = '@ZAPI_SESSION_V3_RECEIVED';
export const SESSION_V3_UPDATED = '@ZAPI_SESSION_V3_UPDATED';

export const SESSION_PARTNER_SET = '@ZAPI_SESSION_PARTNER_SET';
export const SESSION_PARTNER_UNSET = '@ZAPI_SESSION_PARTNER_UNSET';
export const SESSION_DISCOUNT_CODE_SET = '@ZAPI_SESSION_DISCOUNT_CODE_SET';

export const SESSION_CCS_INFO_RECEIVED = '@ZAPI_SESSION_CCS_INFO_RECEIVED';

/**
 * @deprecated use {@link SESSION_V3_HELLO_COMPLETED}
 */
export const SESSION_V2_HELLO_COMPLETED = '@ZAPI_SESSION_HELLO_COMPLETED';

/**
 * @deprecated use {@link SESSION_V3_GOODBYE_COMPLETED}
 */
export const SESSION_V2_GOODBYE_COMPLETED = '@ZAPI_SESSION_GOODBYE_COMPLETED';

/**
 * @deprecated use {@link SESSION_V3_RECEIVED}
 */
export const SESSION_V2_RECEIVED = '@ZAPI_SESSION_RECEIVED';
